<div id="visa_modal" class="modal  custom-modal fade" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_optn_grp_form_title"> {{header}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="visaForm" (ngSubmit)="onSubmitVisa()" class="horizontal-form" method="post" enctype="multipart/form-data">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Country <span class="text-danger">*</span></label>
                                <select class="form-control">
                                   <option value="">Select</option>
                                   <option value="1">1</option>
                                   <option value="2">2</option>
                                </select>
                                <!-- <div *ngIf="submitted && crseErrorMsg.cat_id.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.cat_id.errors.required">Course Category is required !</div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Visa Number<span class="text-danger">*</span></label>
                                <input class="form-control" type="text" placeholder="Visa Number">
                                <!-- <div *ngIf="submitted && crseErrorMsg.course_desc.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.course_desc.errors.required">Visa Number !</div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Valid From<span class="text-danger">*</span></label>
                                <input class="form-control" type="date">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Valid To<span class="text-danger">*</span></label>
                                <input class="form-control" type="date">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Attachment<span class="text-danger">*</span></label>
                                <input class="form-control" type="file">
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm "><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="onReset()" data-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>